import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/NonLinear/PublicationLogStore';
import { isHtmlLink, beginsWith, isStringNullOrWhiteSpace } from '../../tools/validator';
import { toFormattedDate, stringToMoment, getMandatoryBgCss, toDate } from '../../tools/toolkit';
import { DeleteButtonGrid } from '../Controls/DeleteButtonGrid';
import { EditButtonGrid } from '../Controls/EditButtonGrid';
import { LoadingBar } from "../Controls/LoadingBar";
import ModalDialogDelete from '../Controls/ModalDialogDelete';
import ModalDialogError from '../Controls/ModalDialogError';
import { SVMDatePicker } from '../Controls/SVMDatePicker';
import { ExpireDateCompareWithPublishedDate, PublicationMandatoryFieldsMustBeEntered } from '../../messages/businessMessages';
import ModalDialogWarning from '../Controls/ModalDialogWarning';
//import $ from 'jquery';

var selectedRowId;

class PublicationLog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            activeElement: ''
        };
    }

    handleErrorDialogClose = () => {
        this.props.clearErrorMessage();
    }

    handleSelectedRowId(publicationId) {
        selectedRowId = publicationId;
    }

    handleDelete = () => {
        this.props.deletePublication(this.props.programmeId, selectedRowId);
    }

    handleEditPublication(publicationId) {
        this.props.getPublicationLog(this.props.programmeId, publicationId);

        this.setState({ activeElement: 'identifierUpdate' });
    }

    handleCancelPublication(id) {
        this.props.onValidationError([]);
        this.props.getPublicationLog(this.props.programmeId);

        this.setState({ activeElement: 'editButton' + id });
    }

    handleSavePublication = (event, id) => {
        event.preventDefault();

        const data = {
            id: this.refs.publicationIdUpdate.value,
            identifier: this.refs.identifierUpdate.value,
            platform: { id: this.refs.platformIdUpdate.value },
            published: this.refs.publishedUpdate.state.startDate,
            expiry: this.refs.expiryUpdate.state.startDate
        };

        if (!this.validateForm(data)) {
            return false;
        }

        data.published = toDate(data.published).toDateString();
        data.expiry = toDate(data.expiry) ? toDate(data.expiry).toDateString() : undefined;

        this.props.updatePublication(this.props.programmeId, data);
        this.setState({ activeElement: 'editButton' + id });
    }

    handleKeyDown = function (e) {
        if (e.key === 'Enter' && e.shiftKey === false) {
            if (document.activeElement === this.refs.cancelButtonUpdate) {
                e.preventDefault();
                this.refs.cancelButtonUpdate.click();
            }
            else if (document.activeElement === this.refs.saveButtonUpdate) {
                e.preventDefault();
                this.refs.saveButtonUpdate.click();
            }
            else if (document.activeElement.id.lastIndexOf('deleteButton', 0) === 0 || document.activeElement.id.lastIndexOf('editButton', 0) === 0) {
                e.preventDefault();
                document.activeElement.click();
            }
            else if (document.activeElement.type !== 'a') {
                e.preventDefault();
                return false;
            }
            else
                return true;
        }
    }

    validateForm(data) {
        let messages = [];
        let valid = true;

        this.refs.identifierUpdate.classList.remove('mandatoryBg');
        this.refs.platformIdUpdate.classList.remove('mandatoryBg');
        this.refs.publishedUpdate.removeClassName('mandatoryBg');
        this.refs.expiryUpdate.removeClassName('mandatoryBg');

        if (isStringNullOrWhiteSpace(data.identifier)) {
            this.refs.identifierUpdate.classList.add('mandatoryBg');
            messages.push({ controlId: 'identifierUpdate', message: 'Publication Identifier is missing. Please enter an identifier first.' });
            valid = false;
        }

        if (isStringNullOrWhiteSpace(data.platform.id)) {
            this.refs.platformIdUpdate.classList.add('mandatoryBg');
            messages.push({ controlId: 'platformIdUpdate', message: 'Platform is missing. Please select a platform first.' });
            valid = false;
        }

        if (isStringNullOrWhiteSpace(data.published)) {
            this.refs.publishedUpdate.addClassName('mandatoryBg');
            messages.push({ controlId: 'publishedUpdate', message: 'Published Date is missing. Please enter a date first.' });
            valid = false;
        }

        var dateformat = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!isStringNullOrWhiteSpace(data.published) && !data.published.match(dateformat)) {
            this.refs.publishedUpdate.addClassName('mandatoryBg');
            messages.push({ controlId: 'publishedUpdate', message: 'Published Date is invalid. Please enter a valid date first.' });
            valid = false;
        }

        if (!isStringNullOrWhiteSpace(data.expiry) && !data.expiry.match(dateformat)) {
            this.refs.expiryUpdate.addClassName('mandatoryBg');
            messages.push({ controlId: 'expiryUpdate', message: 'Expiry Date is invalid. Please enter a valid date first.' });
            valid = false;
        }

        if (valid && !isStringNullOrWhiteSpace(data.expiry) && stringToMoment(data.expiry) < stringToMoment(data.published)) {
            //$("#invalidExpiryDateMD").modal();
            this.refs.expiryUpdate.addClassName('mandatoryBg');
            messages.push({ controlId: 'expiryUpdate', message: ExpireDateCompareWithPublishedDate });
            valid = false;
        }

        this.props.onValidationError(messages);
        return valid;
    }

    componentDidUpdate() {
        if (this.state.activeElement !== '') {

            switch (this.state.activeElement) {
                case 'identifierUpdate': if (this.refs.identifierUpdate) { this.setState({ activeElement: '' }); this.refs.identifierUpdate.focus(); } break;
            }
            if (beginsWith(this.state.activeElement.toString(), 'editButton')) {
                const control = document.getElementById(this.state.activeElement.toString());

                if (control) {
                    this.setState({ activeElement: '' })
                    control.focus();
                }
            }
        }
    }

    renderListTable() {
        return (
            <div className='container-fluid'>
                <div className='row font-weight-bold'>
                    <div className='col-md-7 pt-1 pl-0'>
                        Publication Identifier
                    </div>
                    <div className='col-md-2 pt-1 pl-0'>
                        Platform
                    </div>
                    <div className='col-md-1 pt-1 pl-0'>
                        Published Date
                    </div>
                    <div className='col-md-1 pt-1 pl-0'>
                        Expiry Date
                    </div>
                </div>
                {this.props.lists.map(item => this.renderPublicationRow(item))}
            </div>
        );
    }

    renderPublicationRow(item) {
        if (this.props.editablePublicationId && item.id === this.props.editablePublicationId) {

            const cancelLabel = 'Cancel edit of publication ' + item.identifier + ' on ' + item.platform.name;
            const updateLabel = 'Save changes for publication ' + item.identifier + ' on ' + item.platform.name;

            return (
                <form onKeyDown={(e) => { this.handleKeyDown(e); }}>
                    <div className='row'>
                        <input type="hidden" name="publicationIdUpdate" value={item.id} ref='publicationIdUpdate' />
                        <div className='col-md-7 pl-0'>
                            <input id='identifierUpdate' name='identifierUpdate' ref='identifierUpdate' className='w-100' type='text' maxLength={2000} defaultValue={item.identifier} aria-required='true' aria-label='Publication log, Edit, publication identifier of the selected publication log' />
                        </div>
                        <div className='col-md-2 pl-0'>
                            <select id='platformUpdate' name='platformIdUpdate' ref='platformIdUpdate' className='dropDownDefaults' defaultValue={item.platform.id} aria-required='true' aria-label='Publication log, Edit, platform of the selected publication log'>
                                <option value="">Select Platform</option>
                                {this.renderPlatforms()}
                            </select>
                        </div>
                        <div className='col-md-1 pl-0'>
                            <SVMDatePicker
                                id='publishedUpdate'
                                name='publishedUpdate'
                                ref='publishedUpdate'
                                className='w-100'
                                value={item.published}
                                canEdit={this.props.canEdit}
                                dateWarningMessage='Published Date'
                                ariaLabel='Publication log, Edit, published date of the selected publication log'
                                ariaRequired='true'
                                onValidationError={(messages) => this.props.onValidationError(messages)} />
                        </div>
                        <div className='col-md-1 pl-0'>
                            <SVMDatePicker
                                id='expiryUpdate'
                                name='expiryUpdate'
                                ref='expiryUpdate'
                                className='w-100'
                                value={item.expiry}
                                minDate={item.published}
                                minDateInputName='publishedUpdate'
                                canEdit={this.props.canEdit}
                                dateWarningMessage='Expiry Date'
                                minDateWarningMessage={ExpireDateCompareWithPublishedDate}
                                ariaLabel='Publication log, Edit, expiry date of the selected publication log'
                                onValidationError={(messages) => this.props.onValidationError(messages)} />
                        </div>
                        <div className='col-md-1 pl-0 pr-0'>
                            <div className='float-right'>
                                <a id='cancelButtonUpdate' ref='cancelButtonUpdate' className='btn btn-link link' tabIndex='0' aria-label={cancelLabel} onClick={() => this.handleCancelPublication(item.id)}>Cancel</a> | <a id='saveButtonUpdate' ref='saveButtonUpdate' className='btn btn-link link' aria-label={updateLabel} tabIndex='0' onClick={(e) => this.handleSavePublication(e, item.id)}>Update</a>
                            </div>
                        </div>
                    </div>
                    <ModalDialogWarning id='invalidExpiryDateUpdateMD' message={ExpireDateCompareWithPublishedDate} className='w-75' />
                    <ModalDialogWarning id='publicationUpdateValidationMD' message={PublicationMandatoryFieldsMustBeEntered} className='w-75' />
                </form>
            );
        }

        const deleteId = `deleteButton${item.id}`;
        const deleteLabel = `Delete publication ${item.identifier} on ${item.platform.name}`;
        const editId = `editButton${item.id}`;
        const editLabel = `Edit publication ${item.identifier} on ${item.platform.name}`;

        return (
            <div key={item.id} className={'row ' + getMandatoryBgCss(this.props.validationResult, 'invalid_expiry_dates', item.id.toString())} onKeyDown={(e) => { this.handleKeyDown(e); }}>
                <div className='col-md-7 pl-0'>
                    {this.renderIdentifier(item.identifier)}
                </div>
                <div className='col-md-2 pl-0'>
                    {item.platform.name}
                </div>
                <div className='col-md-1 pl-0'>
                    {toFormattedDate(item.published)}
                </div>
                <div className='col-md-1 pl-0'>
                    {toFormattedDate(item.expiry)}
                </div>
                <div className='col-md-1 pl-0 pr-0'>
                    {
                        this.props.canEdit
                            ? <div className='float-right'>
                                <DeleteButtonGrid id={deleteId} ref={deleteId} dataTarget='#deleteModalDialog' onClick={() => this.handleSelectedRowId(item.id)} ariaLabel={deleteLabel} /> | <EditButtonGrid id={editId} ref={editId} onClick={() => this.handleEditPublication(item.id)} ariaLabel={editLabel} />
                            </div>
                            : ''
                    }
                </div>
            </div>
        );
    }

    renderPlatforms() {

        if (this.props.platforms) {
            return (
                this.props.platforms.map(item =>
                    <option key={item.id} value={item.id}>{item.name}</option>
                )
            );
        }

        return '';
    }

    renderIdentifier(identifier) {
        let isLink = isHtmlLink(identifier);
        let shortIdentifier = identifier.length > 70 ? identifier.substring(0, 70) + '...' : identifier;
        // it will always be an external link
        if (isLink) {
            return (
                <a data-toggle='tooltip' data-placement='bottom' title={(identifier !== shortIdentifier ? identifier : '')} href={beginsWith(identifier, 'www') ? 'http://' + identifier : identifier} target='_blank' className='link' >
                    {shortIdentifier}
                </a>
            );
        }
        return (
            <span data-toggle='tooltip' data-placement='bottom' title={(identifier !== shortIdentifier ? identifier : '')}>{shortIdentifier}</span>
        );
    }

    render() {
        return (
            <div ref='publicationLogSection'>
                <table style={{ display: 'block' }} summary='All publications are listed in the publication log. An edit link is provided for each publication row. Clicking on the edit link makes all publication log fields for the current publication editable. Click the update link to save changes.'>
                    <div className='container-fluid pt-4'>
                        <div className='row bottomHorizontalRule'>
                            <h2 className='h2tablecell'>Publication Log</h2>
                        </div>
                        <div className='row pl-2 pr-2'>
                            {(this.props.isLoading ? '' : this.renderListTable())}
                        </div>
                    </div>
                    <ModalDialogDelete id='deleteModalDialog' onClickDelete={this.handleDelete} bodyMessage='Are you sure you wish to delete this publication?' className='w-75' />
                    <ModalDialogError id='errorModalDialog' errorData={this.props.errorData} onCloseClick={this.handleErrorDialogClose} hasErrorOccured={this.props.hasErrorOccured} />
                    <LoadingBar isLoading={this.props.isLoading} />
                </table>
            </div>
        );
    }
}

export default connect(
    state => state.publicationLog,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(PublicationLog);


// WEBPACK FOOTER //
// ./src/components/NonLinear/PublicationLog.js